import React, { Component } from "react";

//Redux
import { connect } from "react-redux";
import { setToast } from "./../../../../redux/actions/toast";

// Custom Components
import Tabs from "../../../Tabs/Tabs";

// Component Settings
import GlobalSettings from "./Tabs/Global/GlobalSettings";
import ChannelSetting from "./Tabs/Channel/ChannelSetting";
import RepaymentChannelSettings from "./Tabs/RepaymentChannel/RepaymentChannelSettings";
import LiquidationChannelSettings from "./Tabs/LiquidationChannel/LiquidationChannelSettings";
import CountryLiquidationMapping from "./Tabs/CountryLiquidationMapping/CountryLiquidationMapping";
import MobileVersion from "./Tabs/MobileVersion/mobileVersion";
import ProviderSettings from "./Tabs/ProviderSettings/ProviderSettings";

class AdminSettings extends Component {
  //State
  state = {
    activeTab: "global",
    tabs: [
      {
        name: "Global",
        id: "global",
        icon: "fas fa-globe",
        identifier: "settingsTab",
      },
      {
        name: "Disburse Channel",
        id: "disbursement channel",
        icon: "fas fa-globe",
        identifier: "settingsTab",
      },
      {
        name: "Repay Channel",
        id: "repayment channel",
        icon: "fas fa-globe",
        identifier: "settingsTab",
      },
      {
        name: "Liquidation Channel",
        id: "liquidation channel",
        icon: "fas fa-globe",
        identifier: "settingsTab",
      },
      {
        name: "Local Liquidation Mapping",
        id: "localliquidationmapping",
        icon: "fas fa-money",
        identifier: "settingsTab",
      },
      {
        name: "Mobile Version",
        id: "mobileVersion",
        icon: "fas fa-money",
        identifier: "settingsTab",
      },
      {
        name: "Provider Switch",
        id: "providerSwitch",
        icon: "fas fa-globe",
        identifier: "settingsTab",
      },
    ],
  };

  toggleTabContent = (content) => {
    this.setState({
      activeTab: content,
    });
  };

  setToastHandler = (type, message) => {
    this.props.setToast(type, message);
  };

  componentDidMount = () => {};

  render() {
    const { activeTab, tabs } = this.state;

    return (
      <div className="speed-1x fadeInRight">
        {/* Tabs */}
        <Tabs onContentToggle={this.toggleTabContent} tabs={tabs} />

        <div className="row clearfix grid__padding">
          {/*Datatables*/}
          {(() => {
            switch (activeTab) {
              case "global":
                return (
                  <GlobalSettings
                    onSetToast={this.setToastHandler}
                    // onSubmit={e => {this.submitHandler(e)}}
                  />
                );
              case "disbursement channel":
                return (
                  <ChannelSetting
                    onSetToast={this.setToastHandler}
                    // onSubmit={e => {this.submitHandler(e)}}
                  />
                );
              case "repayment channel":
                return (
                  <RepaymentChannelSettings
                    onSetToast={this.setToastHandler}
                    // onSubmit={e => {this.submitHandler(e)}}
                  />
                );
              case "liquidation channel":
                return (
                  <LiquidationChannelSettings
                    onSetToast={this.setToastHandler}
                    // onSubmit={e => {this.submitHandler(e)}}
                  />
                );
              case "localliquidationmapping":
                return (
                  <div className="col-sm-12 animated delay-3s slideInRight mt-20">
                    <CountryLiquidationMapping
                      onSetToast={this.setToastHandler}
                    />
                  </div>
                );
              case "mobileVersion":
                return <MobileVersion />;

              case "providerSwitch":
                return <ProviderSettings />;

              default:
                return null;
            }
          })()}
        </div>
      </div>
    );
  }
}

export default connect(null, { setToast })(AdminSettings);
